import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import RankDistribution from './components/RankDistribution';

const RankDistributionPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Sales Rank Distribution</h3>
      </Col>
    </Row>
    <Row>
      <RankDistribution />
    </Row>
  </Container>
);

export default RankDistributionPage;
